import { render, staticRenderFns } from "./CreatePointModal.vue?vue&type=template&id=48f48d47&scoped=true"
import script from "./CreatePointModal.vue?vue&type=script&lang=js"
export * from "./CreatePointModal.vue?vue&type=script&lang=js"
import style0 from "./CreatePointModal.vue?vue&type=style&index=0&id=48f48d47&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f48d47",
  null
  
)

export default component.exports